module.exports = __webpack_public_path__ + "static/media/capaSecundaria.32ce8ca3.svg";